import PcoEmailsQueue from './pages/PcoEmailsQueuePage.vue'

const routes = [
  {
    path: 'pco-emails-queue',
    name: 'pco-emails-queue',
    component: PcoEmailsQueue
  }
];

export default routes;
